import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SERVER_API_URL} from 'app/app.constants';
import {saveAs} from 'file-saver';

const fileExtension = {
    'text/csv': 'csv',
    'application/octet-stream': 'zip'
};

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    http: HttpClient;
    constructor(_http: HttpClient) {
        this.http = _http;
    }

    exportAll = async (filterSpec: any, exportType: any, requestUri?: string): Promise<any> => {
        const cleanedFilterSpec: any = {};
        Object.keys(filterSpec || {}).forEach((key) => {
            if (filterSpec[key] !== null && filterSpec[key] !== undefined) {
                cleanedFilterSpec[key] = filterSpec[key];
            }
        });
        const REQUEST_URI = requestUri ?? SERVER_API_URL + 'api/' + exportType + '/export-all';
        const exported = await this.http
            .get(REQUEST_URI, {
                params: cleanedFilterSpec,
                responseType: 'arraybuffer',
                observe: 'response'
            })
            .toPromise();
        const type = exported.headers.get('Content-Type');
        saveAs(new Blob([exported.body], {type}), exportType + '-file.' + fileExtension[type]);
    };

    public getExportSettings = (exportType: any, requestUri?: string): Promise<any> => {
        const REQUEST_URI = requestUri ?? `${SERVER_API_URL}api/export-settings/` + exportType;
        return this.http.get(REQUEST_URI, {observe: 'response'}).toPromise();
    };

    public saveExportSettings = (exportSettings: any, exportType: any, requestUri?: string): Promise<any> => {
        const REQUEST_URI = requestUri ?? `${SERVER_API_URL}api/export-settings/` + exportType;
        return this.http.put<any>(REQUEST_URI, exportSettings, {observe: 'response'}).toPromise();
    };

    public exportSelected = async (selectedIds: any, exportType: any): Promise<any> => {
        const requestParams = new HttpParams().set('ids', selectedIds);
        const REQUEST_URI = `${SERVER_API_URL}api/export/` + exportType;
        const exported = await this.http
            .get(REQUEST_URI, {
                observe: 'response',
                responseType: 'arraybuffer',
                params: requestParams
            })
            .toPromise();
        const type = exported.headers.get('Content-Type');
        saveAs(new Blob([exported.body], {type}), exportType + '-file.csv');
    };

    public exportRouteOptimization = async (filterParams: any): Promise<any> => {
        const REQUEST_URI = SERVER_API_URL + 'api/haulier-orders/route-optimization-export';

        const exported = await this.http
            .get(REQUEST_URI, {
                params: filterParams,
                responseType: 'arraybuffer',
                observe: 'response'
            })
            .toPromise();

        const type = exported.headers.get('Content-Type');
        const fileName = `route-optimization-export-${this.getFormattedDate()}.csv`;
        saveAs(new Blob([exported.body], {type}), fileName);
    };

    public exportSelectedOrders = async (filterParams: any): Promise<any> => {
        const REQUEST_URI = SERVER_API_URL + 'api/HAULIER_ORDER/export-selected';

        const exported = await this.http
            .get(REQUEST_URI, {
                params: filterParams,
                responseType: 'arraybuffer',
                observe: 'response'
            })
            .toPromise();

        const type = exported.headers.get('Content-Type');
        const fileName = `haulier-orders-selected-${this.getFormattedDate()}.csv`;

        saveAs(new Blob([exported.body], {type}), fileName);
    };

    public exportAllAsync = async (filterSpec: any, exportType: any): Promise<number> => {
        const cleanedFilterSpec: any = {};
        Object.keys(filterSpec || {}).forEach((key) => {
            if (filterSpec[key] !== null && filterSpec[key] !== undefined) {
                cleanedFilterSpec[key] = filterSpec[key];
            }
        });
        const REQUEST_URI = SERVER_API_URL + 'api/' + exportType + '/export-all-async';
        const res = await this.http.post<number>(REQUEST_URI, cleanedFilterSpec, {responseType: 'text' as any}).toPromise();
        return Number(res);
    };

    public downloadExport = async (asyncRequestId: number, exportType: string): Promise<void> => {
        const REQUEST_URI = `${SERVER_API_URL}api/${exportType}/export-download/${asyncRequestId}`;
        const exported = await this.http
            .get(REQUEST_URI, {
                responseType: 'arraybuffer',
                observe: 'response'
            })
            .toPromise();
        const type = exported.headers.get('Content-Type');
        const fileName = `${exportType}-export-${this.getFormattedDate()}.csv`;
        saveAs(new Blob([exported.body], {type}), fileName);
    };

    private getFormattedDate(): string {
        const date = new Date();
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    }
}
